// Fuerza navegación del link padre dentro de <summary> (Dawn suele bloquear el click)
document.addEventListener(
  "click",
  (e) => {
    const a = e.target.closest("details.mega-menu > summary .mega-menu__parent-link");
    if (!a) return;

    // Capturamos ANTES que Dawn y forzamos navegación
    e.preventDefault();
    e.stopImmediatePropagation();
    window.location.href = a.href;
  },
  true // 👈 CAPTURE: corre antes que los handlers del tema
);

// Accesibilidad: Enter/Espacio sobre el link también navega
document.addEventListener(
  "keydown",
  (e) => {
    const a = e.target.closest("details.mega-menu > summary .mega-menu__parent-link");
    if (!a) return;
    if (e.key !== "Enter" && e.key !== " ") return;

    e.preventDefault();
    e.stopImmediatePropagation();
    window.location.href = a.href;
  },
  true
);
